export function slugifyAnalyticsSegment(title: string): string {
	if (!title) {
		return '';
	}
	const slug = title
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[\W]/g, '_')
		.replace(/_{2,}/g, '_')
		.replace(/_$/, '')
		.toLowerCase();
	return slug;
}

export function appendIcmpQueryParam(
	url: string | undefined,
	icmpValue: string | undefined
): string | undefined {
	if (!url || !icmpValue) {
		return url;
	}
	try {
		const parsed = new URL(url, 'https://www.fourseasons.com');
		parsed.searchParams.set('_s_icmp', icmpValue);
		if (url.startsWith('http://') || url.startsWith('https://')) {
			return parsed.toString();
		}
		return `${parsed.pathname}${parsed.search}${parsed.hash}`;
	} catch {
		return url;
	}
}
